import {ISignInCallbackProps, ISignUpCallbackProps} from '../types';
import api from './api';

export const sigInCallback = async (data: ISignInCallbackProps) => {
  return await api.post('auth/signin-admin-callback', { data: data });
};

export const sigUpCallback = async (data: ISignUpCallbackProps) => {
  return api.post('auth/signup-admin-callback', { data: data });
};